import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import "../../styles/GuestInfoWindow.css"

function GuestInfoWindow() {
    const navigate = useNavigate();
    const location = useLocation();

    // Odbieramy kod wybranego kraju z przekierowania (jeśli przekazano)
    const selectedCountryCode = location.state?.selectedCountryCode;

    return (
        <div className="guestInfoContainer">
            <div className="guestInfoCard">
                <h2>Odkrywaj i zapisuj swoje podróże!</h2>
                <p>
                    Aby przeglądać relacje z tego kraju, dodawać własne wpisy oraz tworzyć galerię zdjęć, musisz się zalogować lub zarejestrować.
                </p>

                <div className="guestInfoButtons">
                    <button
                        className="btnLogin"
                        onClick={() => navigate('/logowanie', { state: { fromCountry: selectedCountryCode } })}
                    >
                        Zaloguj się
                    </button>

                    <button
                        className="btnRegister"
                        onClick={() => navigate('/rejestracja')}
                    >
                        Zarejestruj się
                    </button>
                </div>

                <button className="btnBack" onClick={() => navigate('/')}>
                    Powrót do strony głównej
                </button>
            </div>
        </div>
    );
};
export default GuestInfoWindow;